var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.14802 11.8101C7.39468 9.5241 10.8937 8.01677 12.645 7.2881C17.644 5.2091 18.682 4.8481 19.359 4.8361C19.509 4.8331 19.841 4.8701 20.057 5.0461C20.239 5.1931 20.289 5.3931 20.313 5.5331C20.337 5.6731 20.367 5.9921 20.343 6.2411C20.073 9.0881 18.9 15.9951 18.303 19.1831C18.051 20.5311 17.555 20.9831 17.073 21.0281C16.028 21.1241 15.235 20.3381 14.223 19.6741C12.638 18.6351 11.743 17.9881 10.205 16.9751C8.42802 15.8041 9.58002 15.1601 10.593 14.1081C10.858 13.8331 15.463 9.6441 15.553 9.2641C15.563 9.2161 15.574 9.0391 15.469 8.9461C15.364 8.8521 15.209 8.8841 15.096 8.9101C14.9367 8.9461 12.406 10.6188 7.50402 13.9281C6.78468 14.4214 6.13402 14.6618 5.55202 14.6491C4.90902 14.6351 3.67202 14.2861 2.75402 13.9871C1.62602 13.6201 0.730017 13.4271 0.808017 12.8041C0.848684 12.4801 1.29535 12.1488 2.14802 11.8101Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.8ca93a5aec12e2b644586f9a6979b2b1.svg";
export { ForwardRef as ReactComponent };